import { ImgixImage, ImgixImageProps } from './ImgixImage'

/**
 * A Next.js Image component that loads a Kontent image.
 * Images from Kontent share the same image loader as Imgix images so we can use the same component.
 */
export function KontentImage(props: ImgixImageProps) {
  return <ImgixImage {...props} />
}
